module.exports = __webpack_public_path__ + "static/works-lifegrip-site-1aa83082c1b5489fefb2094be9583932.png";